import styled from "styled-components";

// This is under a view/page's title
const ViewSubtitle = styled.div`
  color: ${(props) => props.theme.colors.black};
  font-size: 1rem;
  font-weight: 400;
`;
export default ViewSubtitle;
